import merge from 'lodash/merge';
import { getThemeDefaults, mapConfigToLineStyles, isAreaChart } from '@/components/widget/visualizations/internal/LineChart/stylesTheme';
import { selectionConfig } from '@/components/widget/visualizations/internal/LineChart/settings';
import LineStyles from '@/components/Editor/Form/fields/LineStyles';
import { jsx as _jsx } from "react/jsx-runtime";

const WidgetEditFormLineChartCollectionOption = _ref => {
  let {
    nameSpace,
    collectionIndex,
    collectionOption,
    colorPallet,
    defaults,
    onChange
  } = _ref;
  return /*#__PURE__*/_jsx(LineStyles, {
    nameSpace: `${nameSpace}-${collectionIndex}`,
    lineDash: collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.lineDash,
    lineWidth: collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.lineWidth,
    lineColor: collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.lineColor,
    lineBackgroundColor: collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.lineBackgroundColor,
    colorPallet: colorPallet,
    defaults: {
      lineWidth: defaults === null || defaults === void 0 ? void 0 : defaults.lineWidth,
      lineDash: defaults === null || defaults === void 0 ? void 0 : defaults.lineDash,
      lineColor: (defaults === null || defaults === void 0 ? void 0 : defaults.lineColor) || colorPallet[collectionIndex],
      lineBackgroundColor: defaults === null || defaults === void 0 ? void 0 : defaults.lineBackgroundColor
    },
    onChange: onChange
  });
};

export function generateCollectionSettings(_ref2) {
  let {
    theme,
    themeStyles,
    config,
    colorPallet,
    collectionIndex,
    collectionOption
  } = _ref2;
  const defaults = merge({}, getThemeDefaults({
    theme,
    styles: themeStyles,
    config
  }), mapConfigToLineStyles(config)); // Set the default line background to the color pallet if not set
  // for area charts

  const hasBackgroundFill = ['solid', 'fade'].includes(config.areaChartDefaultFill) || isAreaChart(config);

  if (hasBackgroundFill && !defaults.lineBackgroundColor) {
    defaults.lineBackgroundColor = defaults.lineColor || (collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.lineColor) || (colorPallet || [])[collectionIndex];
  }

  return {
    title: 'Line',
    defaults: defaults,
    selectionsLabeled: false,
    selectionConfig: selectionConfig
  };
}
export default WidgetEditFormLineChartCollectionOption;